import 'css-chunk:src/MenuArea/MenuArea.module.scss';export default {
  "menu_icon": "menu_icon__apH4Y",
  "nav": "nav__ri2D8",
  "menu_list": "menu_list__V0WYt",
  "menu_item": "menu_item__xMIYB"
};